import {Pipe, PipeTransform} from '@angular/core';
import moment from 'moment';

/**
 * This pipe handles parsing time from the text value.
 */
@Pipe({
  name: 'timeParse',
})
export class TimeParsePipe implements PipeTransform {

  /**
   * Transforms time, formatted in HH:mm:ss, into a Moment object.
   * @param value the time to be transformed.
   */
  transform(value: string) {
    if (!value) {
      return;
    }

    return moment(value, 'HH:mm:ss');
  }
}
